import React from 'react';
import { Helmet } from 'react-helmet-async';

const TermsSchema = () => {
  const schema = {
    "@context": "https://schema.org",
    "@type": "WebPage",
    "name": "Terms and Conditions | Airport Parking Deals",
    "description": "Read the terms and conditions for using Airport Parking Deals services. Understand your rights, responsibilities, and our booking policies.",
    "url": "https://airportparkingdeals.co.uk/terms-and-conditions",
    "breadcrumb": {
      "@type": "BreadcrumbList",
      "itemListElement": [
        {
          "@type": "ListItem",
          "position": 1,
          "name": "Home",
          "item": "https://airportparkingdeals.co.uk"
        },
        {
          "@type": "ListItem",
          "position": 2,
          "name": "Terms and Conditions",
          "item": "https://airportparkingdeals.co.uk/terms-and-conditions"
        }
      ]
    },
    "about": {
      "@type": "Thing",
      "name": "Terms and Conditions",
      "description": "Legal terms governing the use of Airport Parking Deals' airport parking comparison and booking services."
    }
  };

  return (
    <Helmet>
      <script type="application/ld+json">
        {JSON.stringify(schema)}
      </script>
    </Helmet>
  );
};

export default TermsSchema;

